exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box{height:200px;width:200px;border:2px solid #003767;float:left;margin:10px;position:relative;display:flex;flex-direction:column}.box,.name-box{font-family:Arial,serif}.name-box{font-size:14px;background-color:#003767;width:100%;color:#fff}div.name-box div{padding:3px}img.logo{position:absolute;margin:auto;top:0;left:0;right:0;bottom:0;max-width:100%;max-height:100%;padding:5px}div.logo-box{position:relative;flex:1;height:auto;width:100%;top:0;left:0}.box:hover div.hover-color{height:100%;width:100%;background-color:#b3b3b3;opacity:.5;position:absolute;z-index:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/main/webapp/app/components/generic/tile/tile.component.css
// module id = 208
// module chunks = 0